import { useState, useEffect } from "react";

import TestSample from "../components/test-sample";
import FormSubmit from "../components/test-sample/Form";
import { toast } from "react-hot-toast";

const PRODUCT_HEAD = ["id", "title", "type", "benefitValue", "benefitType"];
const PRODUCT_PROPERTY_HEAD = ["id", "title", "type", "Option"];
const PRODUCT_PROPERTY_Link_HEAD = ["id", "product_id", "product_Property"];
const WHITE_INVENTORY_ITEM_HEAD = [
  "id",
  "product_id",
  "avb_count",
  "buy_order_id",
];
const WHITE_INVENTORY_ITEM_PROPERTY_HEAD = [
  "id",
  "white_inventory_item_id",
  "property_id",
  "value",
];
const PRODUCT_PRICING_HEAD = [
  "id",
  "product_id",
  "product_property_id",
  "conditionOperator",
  "conditionValue",
  "value",
  "changeType", //1 increase, 0 decrease
];
const FORMUL_PRODUCT_HEAD = [
  "id",
  "product_id",
  "made_from_product_id",
  "made_product_condition",
  "count_val",
  "preority",
];
export default function TestSamplePage() {
  const [product, setProduct] = useState([
    {
      title: "فلت بگ",
      id: 0,
      price: 0,
      type: 0, //product for sale
      benefitType: "1", //1percent, 2 cache
      benefitValue: 10,
    },
    {
      title: "باکس بگ",
      id: 1,
      price: 0,
      type: 0, //product for sale
      benefitType: "2", //1percent, 2 cache
      benefitValue: 10000,
    },
    {
      title: "چاپ سیلک",
      id: 2,
      price: 0,
      type: 1, //servicefor sale
      benefitType: "1", //1percent, 2 cache
      benefitValue: 10,
    },
    {
      title: " طاقه پارچه ",
      id: 3,
      price: 0,
      type: 3, //madeAvalie
      benefitType: "1", //1percent, 2 cache
      benefitValue: 10,
    },
    {
      title: " اپراتور چاپ ",
      id: 4,
      price: 0,
      type: 4, //khedmat avalie
      benefitType: "1", //1percent, 2 cache
      benefitValue: 10,
    },
    {
      title: " رنگ چاپ سیلک ",
      id: 5,
      price: 0,
      type: 3, //madeAvalie
      benefitType: "1", //1percent, 2 cache
      benefitValue: 10,
    },
    {
      title: " کلیشه چاپ سیلک ",
      id: 6,
      price: 0,
      type: 3, //madeAvalie
      benefitType: "1", //1percent, 2 cache
      benefitValue: 10,
    },
    {
      title: " اپراتور دوخت ",
      id: 7,
      price: 0,
      type: 4, //khedmat avalie
      benefitType: "1", //1percent, 2 cache
      benefitValue: 10,
    },
    {
      title: "فلت بگ سه تکه",
      id: 8,
      price: 0,
      type: 0, //product for sale
      benefitType: "1", //1percent, 2 cache
      benefitValue: 30000,
    },
  ]);
  const [productProperty, setProductProperty] = useState([
    {
      title: "رنگ پارچه",
      type: 1, /// type of value 0=number 1=choice
      Option: ["ابی", "قرمز", "سبز"],
      id: 0,
    },
    {
      title: "قد کل",
      type: 0, /// type of value 0=number 1=choice
      Option: [],
      id: 1,
    },
    {
      title: "عرض کل",
      type: 0, /// type of value 0=number 1=choice
      Option: [],
      id: 2,
    },
    {
      title: "عطف",
      type: 0, /// type of value 0=number 1=choice
      Option: [],
      id: 3,
    },
    {
      title: "تعداد ضرب چاپ",
      type: 1, /// type of value 0=number 1=choice
      Option: ["یک", "دو"],
      id: 4,
    },
    {
      title: "رنگ چاپ",
      type: 1, /// type of value 0=number 1=choice
      Option: ["taale", "ghermez"],
      id: 5,
    },
    {
      title: "Arz_taghe",
      type: 0, /// type of value 0=number 1=choice
      Option: [],
      id: 6,
    },
    {
      title: " قد تکه اول",
      type: 0, /// type of value 0=number 1=choice
      Option: [],
      id: 7,
    },
    {
      title: "قد تکه دوم",
      type: 0, /// type of value 0=number 1=choice
      Option: [],
      id: 8,
    },
    // {
    //   title: "قد تکه سوم",
    //   type: 0, /// type of value 0=number 1=choice
    //   Option: [],
    //   id: 12,
    // },
    {
      title: "رنگ تکه اول",
      type: 1, /// type of value 0=number 1=choice
      Option: ["ابی", "قرمز", "سبز"],
      id: 9,
    },
    {
      title: "رنگ تکه دوم",
      type: 1, /// type of value 0=number 1=choice
      Option: ["ابی", "قرمز", "سبز"],
      id: 10,
    },
    {
      title: "رنگ تکه سوم",
      type: 1, /// type of value 0=number 1=choice
      Option: ["ابی", "قرمز", "سبز"],
      id: 11,
    },
  ]);
  const [productPropertyLink, setProductPropertyLink] = useState([
    { id: 1, product_id: 1, product_Property: 0 },
    { id: 2, product_id: 1, product_Property: 1 },
    { id: 3, product_id: 1, product_Property: 2 },
    { id: 4, product_id: 1, product_Property: 3 },
    { id: 7, product_id: 0, product_Property: 0 },
    { id: 8, product_id: 0, product_Property: 1 },
    { id: 9, product_id: 0, product_Property: 2 },
    { id: 10, product_id: 0, product_Property: 3 },

    { id: 5, product_id: 3, product_Property: 0 },
    { id: 6, product_id: 3, product_Property: 6 },
    { id: 7, product_id: 8, product_Property: 1 },
    { id: 7, product_id: 8, product_Property: 2 },
    { id: 7, product_id: 8, product_Property: 7 },
    { id: 7, product_id: 8, product_Property: 8 },
    { id: 7, product_id: 8, product_Property: 9 },
    { id: 7, product_id: 8, product_Property: 10 },
    { id: 7, product_id: 8, product_Property: 11 },
  ]);
  const [whInventoryItem, setWhInventoryItem] = useState([
    { id: 1, product_id: 3, avb_count: 200, buy_order_id: 123 },
    { id: 3, product_id: 3, avb_count: 100, buy_order_id: 123 },
    { id: 2, product_id: 5, avb_count: 20, buy_order_id: 13 },
  ]);
  const [whiteInventoryItemProperty, setWhiteInventoryItemProperty] = useState([
    {
      id: 1,
      wh_inventory_item_id: 1,
      prpperty_id: 6,
      value: 78,
    },
    { id: 2, wh_inventory_item_id: 1, prpperty_id: 0, value: 0 },
    { id: 3, wh_inventory_item_id: 2, prpperty_id: 0, value: 0 },
    {
      id: 4,
      wh_inventory_item_id: 3,
      prpperty_id: 6,
      value: 8,
    },
    { id: 5, wh_inventory_item_id: 3, prpperty_id: 0, value: 0 },
  ]);
  const [productPricing, setProductPricing] = useState([
    {
      id: 1,
      product_id: 3,
      product_property_id: 6,
      conditionOperator: ">",
      conditionValue: "13",
      value: "10000",
      changeType: "1",
    },
    {
      id: 2,
      product_id: 3,
      product_property_id: 2,
      conditionOperator: "<",
      conditionValue: "13",
      value: "15000",
      changeType: "1",
    },
    {
      id: 3,
      product_id: 3,
      product_property_id: 1,
      conditionOperator: "=",
      conditionValue: "13",
      value: "13000",
      changeType: "1",
    },
    {
      id: 4,
      product_id: 6,
      product_property_id: 2,
      conditionOperator: "<",
      conditionValue: "13",
      value: "15000",
      changeType: "1",
    },
    {
      id: 5,
      product_id: 0,
      product_property_id: 1,
      conditionOperator: "=",
      conditionValue: "13",
      value: "13000",
      changeType: "1",
    },
  ]);
  const [formulProduct, setFormulProduct] = useState([
    {
      id: 1,
      product_id: 0,
      made_from_product_id: 3,
      made_product_condition: [
        {
          made_product_property_id: 2,
          formul: ">= prpr_id_2 * 2 + 10 + prpr_id_1",
        },
        { made_product_property_id: 0, formul: "= prpr_id_0" },
        { made_product_property_id: 1, formul: "= prpr_id_1 + 15" },
      ],

      count_val: "= prpr_id_1 + 3 * 15", ///vahed un made avalee // inja parche ast
      preority: 0, ///dar service maana darad baray barname rizi service posht ham anjam mishavad
      groupCode: 1,
    },
    {
      id: 3,
      product_id: 0,
      made_from_product_id: 3,
      made_product_condition: [
        {
          made_product_property_id: 2,
          formul: ">= prpr_id_2 * 4 + 10 - prpr_id_1",
        },
        { made_product_property_id: 0, formul: "= prpr_id_0" },
      ],
      count_val: "= prpr_id_2 + 4 * 5", ///vahed un made avalee // inja parche ast
      preority: 1, ///dar service maana darad baray barname rizi service posht ham anjam mishavad
      groupCode: 1,
    },
    {
      id: 2,
      product_id: 0,
      made_from_product_id: 6,
      made_product_condition: [],
      count_val: "= prpr_id_2 * 23 + 15", ///vahed un made avalee // inja nafarsaate
      preority: 1, ///dar service maana darad baray barname rizi service posht ham anjam mishavad, masalan aval bayad dokht bshavad baad 2kme bokhoraad
      groupCode: 1,
    },
    {
      id: 5,
      product_id: 0,
      made_from_product_id: 7,
      made_product_condition: [],
      count_val: "= prpr_id_2 + 22 + 15", ///vahed un made avalee // inja nafarsaate
      groupCode: 1,

      preority: 1, ///dar service maana darad baray barname rizi service posht ham anjam mishavad, masalan aval bayad dokht bshavad baad 2kme bokhoraad
    },
    {
      id: 4,
      product_id: 5,
      made_from_product_id: 6,
      made_product_condition: [],
      count_val: "= prpr_id_1 + 34 - 15", ///vahed un made avalee // inja nafarsaate
      preority: 0, ///dar service maana darad baray barname rizi service posht ham anjam mishavad, masalan aval bayad dokht bshavad baad 2kme bokhoraad
      groupCode: 1,
    },
    {
      id: 11,
      product_id: 8,
      made_from_product_id: 3,
      made_product_condition: [
        {
          made_product_property_id: 7,
          formul: ">= prpr_id_7 * 2 + 10 ",
        },
        { made_product_property_id: 9, formul: "= prpr_id_9" },
      ],
      count_val: "= prpr_id_1 + 2 * 15", ///vahed un made avalee // inja parche ast
      preority: 0, ///dar service maana darad baray barname rizi service posht ham anjam mishavad
      groupCode: 1,
    },
    {
      id: 6,
      product_id: 8,
      made_from_product_id: 3,
      made_product_condition: [
        {
          made_product_property_id: 7,
          formul: ">= prpr_id_7 * 2 + 10 + prpr_id_2",
        },
        { made_product_property_id: 9, formul: "= prpr_id_9" },
      ],
      count_val: "= prpr_id_1 + 25 - 15", ///vahed un made avalee // inja parche ast
      preority: 0, ///dar service maana darad baray barname rizi service posht ham anjam mishavad
      groupCode: 1,
    },
    {
      id: 7,
      product_id: 8,
      made_from_product_id: 3,
      made_product_condition: [
        {
          made_product_property_id: 8,
          formul: ">= prpr_id_8 * 2 + 10 ",
        },
        { made_product_property_id: 10, formul: "= prpr_id_10" },
      ],
      count_val: "= prpr_id_1 + 10 + 15", ///vahed un made avalee // inja parche ast
      preority: 0, ///dar service maana darad baray barname rizi service posht ham anjam mishavad
      groupCode: 2,
    },
    {
      id: 8,
      product_id: 8,
      made_from_product_id: 3,
      made_product_condition: [
        {
          made_product_property_id: 8,
          formul: ">= prpr_id_8 * 2 + 10 + prpr_id_2",
        },
        { made_product_property_id: 10, formul: "= prpr_id_10" },
      ],
      count_val: "= prpr_id_1 * 15", ///vahed un made avalee // inja parche ast
      preority: 0, ///dar service maana darad baray barname rizi service posht ham anjam mishavad
      groupCode: 2,
    },
    {
      id: 9,
      product_id: 8,
      made_from_product_id: 3,
      made_product_condition: [
        { made_product_property_id: 11, formul: "= prpr_id_11" },
      ],
      count_val: "= prpr_id_1 * 15", ///vahed un made avalee // inja parche ast
      preority: 0, ///dar service maana darad baray barname rizi service posht ham anjam mishavad
      groupCode: 3,
    },
    {
      id: 10,
      product_id: 8,
      made_from_product_id: 3,
      made_product_condition: [
        { made_product_property_id: 11, formul: "= prpr_id_11" },
      ],
      count_val: "= prpr_id_1 - 15", ///vahed un made avalee // inja parche ast
      preority: 0, ///dar se`rvice maana darad baray barname rizi service posht ham anjam mishavad
      groupCode: 3,
    },
  ]);
  const [productWeNeed, setProductWeNeed] = useState([]);
  const [enterDataValue, setEnterDataValue] = useState({});
  const changeData = (baseList, id, name, value, setBaseList) => {
    // console.log("object debug", id);
    let temp = baseList;
    temp = temp.map((v) => {
      if (v.id == id) {
        return { ...v, [name]: value };
      } else return v;
    });
    setBaseList(temp);
  };

  const productOptionList = (productId) => {
    let temp = productPropertyLink.filter((v) => v.product_id == productId);
    let temp2 = temp.map(
      (value) =>
        productProperty.filter((v) => v.id == value.product_Property)[0]
    );
    console.log("object temp debug", temp2);
    return temp2.map((v) => {
      return { ...v, value: v.id, label: v.title };
    });
  };
  const formulFunc = (productId) => {
    let x = formulProduct.filter((v) => v.product_id == productId);
    let z = [];
    let w = [];
    for (let i = 0; i < x.length; i++) {
      let xxx = z.findIndex(
        (element) => element?.made_from_product_id == x[i].made_from_product_id
      );
      if (xxx == -1) {
        z.push({
          made_from_product_id: x[i].made_from_product_id,
          formuls: [x[i]],
        });
      } else z[xxx].formuls.push(x[i]);
    }
    w = z.map((value) => {
      return {
        made_from_product_id: value.made_from_product_id,
        formuls: value.formuls.sort((a, b) => b.preority - a.preority),
      };
    });
    return w;
  };

  const productPricingFunc = (formulList, optionList, productId) => {
    let price = 0;
    let madeProductIdList = formulList.map((v) => v.made_from_product_id);
    let pp = productPricing.filter((v) =>
      madeProductIdList.includes(v.product_id)
    );
    price += +product.filter((v) => v.id == productId)[0]?.benefitValue ?? 0;

    for (let i = 0; i < optionList.length; i++) {
      let x = pp.filter((v) => v.product_property_id == optionList[i].id);
      // console.log("price", x, optionList);

      if (x.length > 0) {
        switch (x[0]?.conditionOperator) {
          case ">":
            if (
              optionList[i]?.enterValue > x[0]?.conditionValue &&
              optionList[i]?.id == x[0]?.product_property_id
            ) {
              price += +x[0]?.value;
            }
            break;
          case "<":
            if (
              optionList[i]?.enterValue < x[0]?.conditionValue &&
              optionList[i]?.id == x[0]?.product_property_id
            ) {
              price += +x[0]?.value;
            }
            break;
          case "=":
            if (
              optionList[i]?.enterValue == x[0]?.conditionValue &&
              optionList[i]?.id == x[0]?.product_property_id
            ) {
              price += +x[0]?.value;
            }
            break;
          default:
            price += 0;
        }
      }
    }
    console.log("formullllll", pp, optionList);
  };

  const whiteHouseFunc = (formulList, optionList, count) => {
    let white = whInventoryItem.map((v) => {
      return {
        ...v,
        items: whiteInventoryItemProperty.filter(
          (value) => value.wh_inventory_item_id == v.id
        ),
      };
    });
    checkPropertyFunc(white, 3, optionList, count, formulList);
    // console.log("formul white", white);
    // console.log("formul formulList", formulList);
  };
  const checkPropertyFunc = (
    white,
    productId,
    optionList,
    count,
    formulList
  ) => {
    // let withhouseList = white.filter((v) => v.product_id == productId);
    // let list = [];
    // let whatweNedd = [];
    let enterValueTemp = {};
    let array = [];
    let formulListTemp = formulList.map((value) => {
      return {
        ...value,
        formuls: value?.formuls?.map((v) => {
          return {
            ...v,

            made_product_condition: v?.made_product_condition?.map((vv) => {
              return {
                ...vv,
                property_info:
                  productProperty.filter(
                    (val) => val.id == vv.made_product_property_id
                  )[0] ?? {},
              };
            }),
          };
        }),
        made_product_info:
          product.filter((v) => v.id == value.made_from_product_id)[0] ?? {},
      };
    });
    array = formulListTemp.map((v) => {
      return { ...v, formuls: groupByFunc(v.formuls, "groupCode") };
    });
    setProductWeNeed(array);

    optionList.map((v) => {
      enterValueTemp[`prpr_id_${v.id}`] = v.enterValue;
    });
    setEnterDataValue(enterValueTemp);
    console.log("object", enterValueTemp, formulList);
  };
  const convertFormul = (
    string = "<= 99 - 10 * 4 + 3 * 2 + 10",
    value = 42,
    type = "compare" //value
  ) => {
    let list = string.split(" ");

    let mainOperator = list[0] ?? 0;
    let operatorMainFa = "";
    let compareValue = 0;
    list = type == "compare" ? list.splice(1) : list;
    console.log("object eval eval list", list);

    let newList = list.map((v) => {
      if (v.includes("prpr_id_")) {
        let pro = {};
        if (enterDataValue[v]) return enterDataValue[v];
        else {
          let t = v.split("_");
          let prId = t[t.length - 1];
          pro = productProperty.filter((v) => v.id == prId)[0];
        }
        toast.error(`اپشن ${pro?.title} به محصول متصل نیست`);
        return 0;
      } else return v;
    });
    let result = "";
    let multipleIndex = newList.indexOf("*");
    let divideIndex = newList.indexOf("/");
    let plusIndex = newList.indexOf("+");
    let minuesIndex = newList.indexOf("-");
    switch (mainOperator) {
      case "=":
        result = parseInt(newList[0]) == parseInt(value);
        operatorMainFa = "مساوی";
        break;
      case ">=":
        result = parseInt(value) >= parseInt(newList);
        operatorMainFa = " بزرگتر مساوی";
        break;
      case ">":
        result = parseInt(value) > parseInt(newList);
        operatorMainFa = " بزرگتر ";

        break;
      case "<=":
        result = parseInt(value) <= parseInt(newList);
        operatorMainFa = " کوچکتر مساوی";

        break;
      case "<":
        result = parseInt(value) < parseInt(newList);
        operatorMainFa = " کوچکتر";

        break;
      default:
        result = "";
        break;
    }

    if (
      multipleIndex != -1 ||
      divideIndex != -1 ||
      plusIndex != -1 ||
      minuesIndex != -1
    ) {
      console.log("object eval eval newList", newList);
      compareValue = eval(newList.toString().replaceAll(",", ""));
    } else compareValue = newList;
    // let value2 = 0;
    // do {
    //   let multipleIndex = newList.indexOf("*");
    //   let divideIndex = newList.indexOf("/");
    //   let plusIndex = newList.indexOf("+");
    //   let minuesIndex = newList.indexOf("-");

    //   if (multipleIndex != -1) {
    //     let x = newList[multipleIndex - 1];
    //     // let y = newList[multipleIndex];
    //     let z = newList[multipleIndex + 1];
    //     newList.splice(
    //       multipleIndex - 1,
    //       3,
    //       (parseInt(x) * parseInt(z)).toString()
    //     );
    //   } else if (divideIndex != -1) {
    //     let x = newList[divideIndex - 1];
    //     let y = newList[divideIndex];
    //     let z = newList[divideIndex + 1];
    //     newList.splice(
    //       divideIndex - 1,
    //       3,
    //       (parseInt(x) / parseInt(z)).toString()
    //     );
    //   } else if (plusIndex != -1) {
    //     let x = newList[plusIndex - 1];
    //     let y = newList[plusIndex];
    //     let z = newList[plusIndex + 1];
    //     newList.splice(
    //       plusIndex - 1,
    //       3,
    //       (parseInt(x) + parseInt(z)).toString()
    //     );
    //   } else if (minuesIndex != -1) {
    //     let x = newList[minuesIndex - 1];
    //     let y = newList[minuesIndex];
    //     let z = newList[minuesIndex + 1];
    //     newList.splice(
    //       minuesIndex - 1,
    //       3,
    //       (parseInt(x) - parseInt(z)).toString()
    //     );
    //   } else {
    //   }
    //   if (newList.length == 1) {
    //     switch (mainOperator) {
    //       case "=":
    //         result = parseInt(newList[0]) == parseInt(value);
    //         operatorMainFa = "مساوی";
    //         break;
    //       case ">=":
    //         result = parseInt(value) >= parseInt(newList);
    //         operatorMainFa = " بزرگتر مساوی";
    //         break;
    //       case ">":
    //         result = parseInt(value) > parseInt(newList);
    //         operatorMainFa = " بزرگتر ";

    //         break;
    //       case "<=":
    //         result = parseInt(value) <= parseInt(newList);
    //         operatorMainFa = " کوچکتر مساوی";

    //         break;
    //       case "<":
    //         result = parseInt(value) < parseInt(newList);
    //         operatorMainFa = " کوچکتر";

    //         break;
    //     }
    //   }
    // } while (newList.length != 1);
    return {
      operator: operatorMainFa,
      compareValue: compareValue ?? 0,
      result: result,
    };
  };
  const groupByFunc = (array, groupField) => {
    function groupBy(objectArray, property) {
      return objectArray.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});
    }
    const groupedPeople = groupBy(array, groupField);
    return groupedPeople;
  };
  const inquiry = (optionList, productId, count) => {
    let price = 0;
    let formulList = formulFunc(productId);
    whiteHouseFunc(formulList, optionList, count);
    return { price: price };
  };
  console.log("productWeNeed", productWeNeed);
  return (
    <div>
      <div className="m-3 d-flex flex-wrap">
        <div className="">
          product table
          <TestSample
            head={PRODUCT_HEAD}
            data={product}
            changeData={changeData}
            setData={setProduct}
          />
        </div>
        <div className="">
          product Property table
          <TestSample
            head={PRODUCT_PROPERTY_HEAD}
            data={productProperty}
            changeData={changeData}
            setData={setProductProperty}
          />
        </div>
        <div className="">
          product Property link table
          <TestSample
            head={PRODUCT_PROPERTY_Link_HEAD}
            data={productPropertyLink}
            changeData={changeData}
            setData={setProductPropertyLink}
          />
        </div>
        <div className="">
          white inventory item table
          <TestSample
            head={WHITE_INVENTORY_ITEM_HEAD}
            data={whInventoryItem}
            changeData={changeData}
            setData={setWhInventoryItem}
          />
        </div>
        <div className="">
          white inventory item property table
          <TestSample
            head={WHITE_INVENTORY_ITEM_PROPERTY_HEAD}
            data={whiteInventoryItemProperty}
            changeData={changeData}
            setData={setWhiteInventoryItemProperty}
          />
        </div>
        <div className="">
          product pricing table
          <TestSample
            head={PRODUCT_PRICING_HEAD}
            data={productPricing}
            changeData={changeData}
            setData={setProductPricing}
          />
        </div>
        <div className="">
          formul product table
          <TestSample
            head={FORMUL_PRODUCT_HEAD}
            data={formulProduct}
            changeData={changeData}
            setData={setFormulProduct}
          />
        </div>
      </div>
      <hr className="my-3" />

      <FormSubmit
        productOption={product.map((v) => {
          return { value: v.id, label: v.title, ...v };
        })}
        productOptionList={productOptionList}
        inquiry={inquiry}
      />

      <div>
        {productWeNeed.map((v, i) => {
          return (
            <div className="my-2" key={`product-we-need-${i}`}>
              {v?.made_product_info?.title}
              <div>
                {Object.keys(v?.formuls).map((val, ind) => {
                  return (
                    <div className="my-1 mx-4">
                      <p className="bg-secondary text-light ps-3 py-1">
                        تکه {val}
                      </p>
                      <ul>
                        {v.formuls[val]?.map((vvv, ind) => {
                          let valueTemp2 = convertFormul(vvv.count_val);
                          console.log(
                            "object",
                            valueTemp2,
                            vvv.count_val,
                            "value"
                          );
                          return (
                            <div>
                              <p>{ind}</p>
                              <p>
                                طول طاقه بازای هر عدد :{" "}
                                {valueTemp2?.compareValue}
                              </p>
                              {vvv?.made_product_condition?.map((vv) => {
                                let valueTemp = convertFormul(vv.formul);

                                return (
                                  <li className="my-2">
                                    {vv?.property_info?.title} &nbsp;
                                    {valueTemp?.operator} &nbsp;
                                    {valueTemp?.compareValue}
                                  </li>
                                );
                              })}
                            </div>
                          );
                        })}
                      </ul>
                    </div>
                  );
                })}
              </div>
              <hr />
            </div>
          );
        })}
        <button
          className="bg-warning text-light  btn"
          onClick={() => {
            const array = {
              1: [{ name: "a" }],
              2: [{ name: "b" }],
              3: [{ name: "c" }],
            };
            Object.keys(array).forEach((value) =>
              console.log("object test", array[value], value)
            );
            console.log("test");
          }}
        >
          test
        </button>
      </div>
    </div>
  );
}
